exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._contact-title{font-weight:600}._max-width{width:60rem;margin:auto}", ""]);

// exports
